<template>
  <div class="analysis-page">
    <!--   导航按钮     -->
    <div class="nav-wrap">
      <div @click="navToRouter(nav.path)" class="nav-item" :class="{ 'active-nav-item': nav.active }" v-for="nav in arrNavList" :key="nav.path">
        <!--       标题容器         -->
        <div class="title-content">
          <img v-if="nav.active" :src="nav.activeIcon" class="icon" alt="" />
          <img v-else :src="nav.icon" class="icon" alt="" />
          <div class="title">
            <p v-for="p in nav.name" :key="p">{{ p }}</p>
          </div>
        </div>
        <!--        摘要信息容器        -->
        <div class="sum-content">
          <p>{{ nav.util }}总数{{ nav.utilValue }}家</p>
        </div>
      </div>
    </div>
    <!--    路由试图    -->
    <router-view></router-view>
  </div>
</template>

<script>
import { getEarthTotal } from "@/js/service";
import {fetchVerifyAuthForB} from '@/libsV2/havc.js';
export default {
  name: "index",
  data() {
    return {
      // 导航数组
      arrNavList: [
        {
          icon: require("@/assets/images/service/customerscoring/service-eva.png"),
          activeIcon: require("@/assets/images/service/customerscoring/service-eva-ac.png"),
          name: ["全国冷暖风水", "服务能力评分"],
          util: "项目",
          utilValue: 0,
          path: "/hvac/customerscoring/analysis/score",
          active: true,
        },
        {
          icon: require("@/assets/images/service/customerscoring/service-user.png"),
          activeIcon: require("@/assets/images/service/customerscoring/service-user-ac.png"),
          name: ["服务商", "能力排名"],
          util: "服务商",
          utilValue: 0,
          path: "/hvac/customerscoring/analysis/ranking",
        },
      ],
    };
  },
  mounted() {
        fetchVerifyAuthForB(()=>{
            this.$store.commit("loadSwitch", true);
            this.getProjectNum()
            this.initRouteLinkClass()
    })

    // $init(() => {
    //   this.$store.commit("loadSwitch", true);
    //   Promise.all([this.getProjectNum(), this.initRouteLinkClass()]).then((res) => {
    //   });
    // });
  },
    watch: {
    $route(to, from) {
        if(to.path==='/hvac/customerscoring/analysis/score'){
                this.initRouteLinkClass(to.path)
        }else if(to.path==='/hvac/customerscoring/analysis/ranking'){
             this.initRouteLinkClass(to.path)
        }
    },
  },
  methods: {
    //   获取项目总数以及服务商总数
    getProjectNum() {
      getEarthTotal().then((res) => {
          this.$store.commit("loadSwitch", false);
        this.arrNavList[0].utilValue = res.data.data.result.contract_num;
        this.arrNavList[1].utilValue = res.data.data.result.company_num;
      });
    },
    /**
     * 导航点击
     * @param { string } path
     */
    async navToRouter(path) {
      await this.$router.push(path);
      await this.initRouteLinkClass(path);
    },
    /**
     * 设置路由的激活样式
     */
    initRouteLinkClass(_path) {
      const path = _path ?? this.$route.path;
      this.arrNavList = this.arrNavList.map((i) => {
        i.active = false;
        i.path === path && (i.active = true);
        return i;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.analysis-page {
  .nav-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .nav-item {
      width: 340px;
      height: 170px;
      border-radius: $commonRadius;
      background: #ffffff;
      color: $deepGreen;
      padding: 0 16px;
      font-size: $baseSize;
      transition: all 0.2s;

      .title-content {
        display: flex;
        margin-bottom: 10px;
        padding: 8px 4px 2px;
        align-items: center;
        background: linear-gradient(to right, rgba(244, 244, 244, 1) 50%, transparent 50%) repeat-x left bottom / 16px 2px;

        .icon {
          width: 104px;
          height: 104px;
          margin-right: 10px;
        }

        .title {
          p {
            line-height: 40px;
            font-weight: 500;
          }
        }
      }

      .sum-content {
        font-size: $smallSize;
        line-height: 32px;
        text-align: center;
        margin-bottom: 12px;
        color: #858585;
      }
    }

    .active-nav-item {
      background: $userBgGradient;
      color: #ffffff;

      .title-content {
        background: linear-gradient(to right, rgba(244, 244, 244, 0.2) 50%, transparent 50%) repeat-x left bottom / 16px 2px;
      }

      .sum-content {
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }
}
</style>
